/*
  The base url is set to dh devqa for local development. 
  It could be any thing else for the development needs
*/
const baseUrl =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
    ? `https://www.dh.eis-deliverydevqa.cloud`
    : "";

const apiConfig = {
  baseUrl,
  personalizationEdge: `${baseUrl}/api/personalization`,
};

export default apiConfig;
